import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { Handshake, Mail, Phone, Calendar, User, Building2 } from 'lucide-react';

export default function PartnersPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('partners')
      .select('*, companies(name)')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-cyan-400 flex items-center gap-2">
        <Handshake size={24} />
        Partenaires ({data.length})
      </h2>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.map(partner => (
            <div key={partner.id} className="bg-gray-900 rounded-xl border border-gray-800 p-5 hover:border-cyan-500/50 transition">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                  <User size={20} className="text-white" />
                </div>
                <div>
                  <h3 className="text-white font-medium">{partner.full_name}</h3>
                  <p className="text-xs text-gray-500">{partner.role}</p>
                </div>
              </div>
              
              <div className="space-y-2 text-sm">
                <p className="text-gray-400 flex items-center gap-2">
                  <Mail size={14} className="text-gray-500" />
                  <a href={`mailto:${partner.email}`} className="hover:text-cyan-400">
                    {partner.email}
                  </a>
                </p>
                <p className="text-gray-400 flex items-center gap-2">
                  <Building2 size={14} className="text-gray-500" />
                  {partner.companies?.name || 'Entreprise non spécifiée'}
                </p>
                <p className="text-gray-500 text-xs flex items-center gap-1 mt-2">
                  <Calendar size={12} />
                  Partenaire depuis: {new Date(partner.created_at).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
